<template>
    <toolbar-option>
        <template slot="primary">
            <input v-model="value" type="text">

            <div class="option__multi">
                <span class="option__multi-label">
                    Flex Form Endpoints
                </span>

                <div class="option__input">
                    <dropdown
                        :value="premadeEndpoint"
                        :options="formOptions"
                        @input="onFormSelect"
                    />
                </div>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import gql from 'graphql-tag';
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'form-data';

export default {
    name: 'form-endpoint',
    mixins: [baseOption],

    apollo: {
        formData: {
            query: gql`
                {
                    item(path: "/sitecore/content/Data/Forms") {
                        children {
                            id
                            name
                        }
                    }
                }
            `,

            update(data) {
                return data.item.children;
            },
        },
    },

    data() {
        return {
            displayName: 'Form Submission URL',
            value: '',
            premadeEndpointNew: '',
        };
    },

    computed: {
        formOptions() {
            if (!this.formData) return [];

            const options = this.formData.map((data) => {
                return {
                    text: data.name,
                    value: data.id,
                };
            });

            options.unshift({
                text: 'Select One',
                value: '',
            });

            return options;
        },

        premadeEndpoint() {
            if (this.premadeEndpointNew) {
                return this.premadeEndpointNew;
            }
            return this.value?.substring(this.value?.indexOf('FlexFormId=') + 'FlexFormId='.length);
        },
    },

    watch: {
        value() {
            if (!this.value) return;

            this.selectedElements[0].mergeElementData(CUSTOM_ATTR_NAME, { action: this.value });
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            let valueNew = '';

            if (this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME)) {
                valueNew = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME).action;
            }

            this.value = valueNew;
        },

        onFormSelect(value) {
            if (value) {
                this.premadeEndpointNew = value;
                const webString = process.env.VUE_APP_GRAPHQL_WEB;
                const webKey = webString.substring(webString.indexOf('sc_apikey='));
                this.value = `/sitecore/api/ssc/flex/FlexForms/1/Submit?${ webKey }&FlexFormId=${ value }`;
            }
        },
    },
};
</script>
